<template>
  <div style="text-align: center; color: black;">
    <div>
      <b-jumbotron>
        <h1
          style="padding-bottom: 1%;padding-top:2%; font-size: 60px;font-family: 'Oswald', sans-serif;"
        >
          <b>{{ newShopDetails.name }}</b>
        </h1>
        <b-button @click="show = !show" variant="primary" href="#"
          >Show Address</b-button
        >
      </b-jumbotron>
    </div>
    <h3><b>Vendor Name</b> : {{ shopkeeper.name }}</h3>
    <h4><b>Mobile Number</b> : {{ shopkeeper.number }}</h4>
    <h4 style="padding-bottom: 3%">
      <b>Shop Email</b> : {{ newShopDetails.email }}
    </h4>
    <div v-if="show">
      <h3><b>Shop Address</b></h3>
      <h5>{{ newShopDetails.address.firstLine }}</h5>
      <h5 style="padding-bottom: 5%">
        {{ newShopDetails.address.city }}, {{ newShopDetails.address.state }} -
        {{ newShopDetails.address.pincode }}
      </h5>
    </div>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
export default {
  data() {
    return {
      newShopDetails: {},
      shopkeeper: {},
      show: false
    };
  },
  mounted() {
    this.setupFirebaseReading();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind(
        "vendor",
        dbFs.collection("vendor").doc(this.$route.params.vendorId)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.newShopDetails = this.vendor.shopDetails;
          this.shopkeeper = this.vendor.personalDetails;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
/* @import url("https://blackrockdigital.github.io/startbootstrap-sb-admin-2/vendor/fontawesome-free/css/all.min.css"); */
@import url("https://fonts.googleapis.com/css2?family=Oswald:wght@700&display=swap");
</style>
